import { IResult } from '../types/IResponse';
import { Request } from './Request';

export interface IUpdateExpiredPasswordParams {
  username: string;
  oldEncryptedPassword: string;
  newEncryptedPassword: string;
  encryptionKeyId: string;
}

export class UpdateExpiredPasswordRequest extends Request<IUpdateExpiredPasswordParams, IResult> {
  constructor(params: IUpdateExpiredPasswordParams) {
    super('updateExpiredPassword', params);
  }
}
